<template>
  <div>
    <button
      type="button"
      class="btn btn--mini btn--only-icon btn--blue circle-button float-right"
      data-toggle="modal"
      data-target="#exampleModal"
      id="refreshStackedBarBtn"
      @click="refreshStackedBar()"
    >
    <i class="fa-solid fa-eye"></i>
    </button>
    <br>
    <div class="myStackedBar" id="myP1">
      <div class="modal-body">
        <h4>
          {{ titleGraph }}
        </h4>
        <bar-line-chart
          :ref="this.stackedBarRef"
          :url="url"
          :string-parameters="stringParameters"
        >
        </bar-line-chart>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stackedBarRef: "",
    };
  },
  mounted() {    
    this.stackedBarRef = "bar-line-toogle" + this.refBar;
    setTimeout(() => {
      this.refreshStackedBar()
    }, 2000);
    
  },
  methods: {
    refreshStackedBar() {
      if (document.getElementById("myP1").style.visibility == "visible") {
        document.getElementById("myP1").style.visibility = "hidden";
        document.getElementById("myP1").style.height = "0px";
      } else {
        document.getElementById("myP1").style.visibility = "visible";
        document.getElementById("myP1").style.height = "500px";

        var url = this.url;
        if (this.stringParameters != null && this.stringParameters != "") {
          url += "?" + this.stringParameters;
        }        
        app.__vue__.appendLoader();
        axios.get(url).then((response) => {          
          this.$refs[this.stackedBarRef].drawBarLineGraph(response.data);
          app.__vue__.removeLoader();          
        });
      }
    },
  },
  props: {
    refBar: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    stringParameters: {
      type: String,
      required: false,
    },
    titleGraph: {
      type: String,
      required: false,
      default: ''
    },
    buttonCollpaseDescprition: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
.myStackedBar {
  visibility: hidden;
  height: 0px;
}
</style>